module.exports = __webpack_public_path__ + "static/wherewework_map2@2x-f02f8c133d7b7cb88410a91dc586cb0e.png";